const DEFAULT_MAX_STARS = 5;

const getRoundedStarRating = (
  averageRating: number,
  maxStars: number = DEFAULT_MAX_STARS
): number => {
  const normalizedRating = Math.min(Math.max(averageRating, 0), maxStars);
  const baseStars = Math.floor(normalizedRating);
  const fractionalPart = normalizedRating - baseStars;
  const epsilon = Number.EPSILON * 10;
  let roundedStarRating = baseStars;

  if (fractionalPart + epsilon >= 0.75) {
    roundedStarRating = Math.min(baseStars + 1, maxStars);
  } else if (fractionalPart + epsilon >= 0.25) {
    roundedStarRating = Math.min(baseStars + 0.5, maxStars);
  }

  return roundedStarRating;
};

export default getRoundedStarRating;
